import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CustomModal } from "@modules/core/components/base-modals";

@Component({
	templateUrl: "./deposit-error.component.html",
	styleUrls: ["../deposit-common-end-screen/deposit-common-end-screen.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class DepositErrorComponent extends CustomModal {
	@Input() public headline: string = "";

	public constructor() {
		super();
	}

	public changeDepositMethod(): void {
		this.close("changeDepositMethod");
	}
}
